export default __webpack_public_path__ + "static/media/double1.ad651312.jpg";